<template>
  <div v-if="method">
    <slot :method="method" />
  </div>
  <div v-else-if="empty && isEmpty">
    <slot name="empty" />
  </div>
</template>

<script>
import usePaymentMethods from '@/compositions/accounting/usePaymentMethods';
import { computed, toRefs } from '@vue/composition-api';

export default {
  name: 'PaymentMethodResolver',
  props: {
    id: {
      type: Number,
      default: null,
    },
    active: Boolean,
    empty: Boolean,
  },
  setup(props) {
    const { id, active } = toRefs(props);
    const { paymentMethods, fetchAll } = usePaymentMethods();
    fetchAll(true);
    return {
      method: computed(() => paymentMethods.value.find((m) => {
        if (active.value) {
          return m.active;
        }
        return m.id === id.value;
      })),
      isEmpty: computed(() => !(paymentMethods.value?.length > 0)),
    };
  },
};
</script>

<style scoped>

</style>
